<template>
    <Teleport to="body">
        <TransitionFade>
            <div class="modal-popup" v-bind="$attrs" v-if="modelValue">
                <div class="modal-popup__background" @click="closeModalInternal"></div>

                <div class="modal-popup__content">
                    <span class="modal-popup__close" @click="closeModalInternal"></span>
                    <slot></slot>
                </div>
            </div>
        </TransitionFade>
    </Teleport>
</template>

<script setup lang="ts">
import { onBeforeUnmount, watch } from "vue";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import { useStackedModals } from "@sazka/utils/composables/use-stacked-modals";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps<{
    modelValue: boolean;
}>();

const closeModalInternal = () => emit("update:modelValue", false);

const keyDownEventHandler = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
        closeModalInternal();
    }
};

const { addToStackedModals, removeFromStackedModals } = useStackedModals();
const modalIsClosing = () => {
    removeFromStackedModals();
    window.removeEventListener("keydown", keyDownEventHandler);
};

const modalIsOpening = () => {
    addToStackedModals();
    window.addEventListener("keydown", keyDownEventHandler);
};

watch(
    () => props.modelValue,
    (newModelValue, oldModelValue) => {
        if (newModelValue && !oldModelValue) {
            modalIsOpening();
        } else if (!newModelValue && oldModelValue) {
            modalIsClosing();
        }
    },
    { immediate: true }
);

onBeforeUnmount(() => {
    if (props.modelValue) {
        modalIsClosing();
    }
});
</script>
